import styled from 'styled-components';
import { Breadcrumb as BreadcrumbAntd } from 'antd';
import color from '../../configs/color';
import boxShadow from '../../configs/boxShadow';
import thumbStyle from '../../configs/thumbStyle';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  height: 64px;

  .component_pageHeader_title {
    max-width: 800px;
    margin-right: 12px;
  }
  .component_pageHeader_breadcrumb {
    display: flex;
    align-items: center;
    margin-right: 12px;
  }

  .component_pageHeader_user_skeleton {
    display: flex;
    align-items: center;
    column-gap: 10px;
    > div:first-child {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .ant-skeleton-button {
        height: 16px;
        width: 180px;
        vertical-align: middle;
      }
      .ant-skeleton:first-child .ant-skeleton-button {
        width: 140px;
      }
    }
    > div:last-child {
      .ant-skeleton-avatar {
        width: 44p;
      }
    }
  }

  .component_pageHeader_user {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    column-gap: 24px;
    .component_pageHeader_user_information_wrapper {
      .component_accountCard {
        flex-direction: row-reverse;
        justify-content: flex-start;
        cursor: pointer;
        text-align: right;
        .font-paragraph_medium {
          max-width: 220px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: ${color.black1};
        }
        .font-caption {
          max-width: 220px;
          font-weight: 600;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: ${color.black3};
        }
        .ant-avatar {
          margin-right: 0;
          margin-left: 10px;
          height: 44px !important;
          min-width: 44px;
          background-color: ${color.orange2};
          width: 44px !important;
          .ant-avatar-string {
            line-height: 47px !important;
            color: white;
          }
        }
      }
    }
    .component_pageHeader_user_bell_icon {
      cursor: pointer;
      .anticon {
        font-size: 24px;
        color: ${color.black2};
      }
      .ant-badge-dot {
        width: 8px;
        height: 8px;
        background: ${color.orange1};
      }

      .ant-badge-count,
      .ant-badge-dot,
      .ant-badge .ant-scroll-number-custom-component {
        top: 4px;
        right: 4px;
      }
    }
  }

  .text-wrapper {
    max-width: 100%;
    max-height: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: pre-wrap;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  .component_page_header_account_card {
    .component_account_card_description {
      max-width: 220px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* number of lines to show */
      -webkit-box-orient: vertical;
    }
  }
`;

export default Wrapper;

export const Breadcrumb = styled(BreadcrumbAntd)`
  color: ${color.black2};
  font-weight: 700;
  font-size: 16px;

  .component_pageHeader_breadcrumb_link {
    color: ${color.black2} !important;
  }
  .last {
    font-weight: 400;
  }
`;

export const SwitchAccountWrapper = styled.div`
  display: ${({ isShow }) => {
    return isShow ? 'block' : 'none';
  }};
  position: absolute;
  right: 0;
  z-index: 10;
  .ant-spin-blur {
    opacity: 1;
  }
  .container_page_header_switch_account {
    position: relative;
    background: white;
    width: 362px;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: ${boxShadow.normal};
    border: 1px solid ${color.grey1};
    .component_switch_account_body {
      max-height: 307px;
      /* min-height: 180px; */
      margin: 20px 0;
      padding: 0 20px;
      display: flex;
      flex-direction: column;
      row-gap: 16px;
      overflow-y: auto;
      ${thumbStyle};
      .component_switch_account_list_item {
        padding: 5px 12px;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .component_accountCard {
          .ant-avatar-circle {
            height: 44px !important;
            width: 44px !important;
            line-height: 44px !important;
          }
          .ant-avatar-string {
            margin-top: 2px;
          }
        }
        .component_switch_account_list_item_icon {
          color: ${color.green1};
          font-size: 17.5px;
        }
        &.active {
          background: ${color.grey3};
        }
        :hover,
        :focus,
        :active {
          background: ${color.grey3};
        }
      }
    }
    .component_switch_account_footer {
      border-top: 1px solid ${color.grey1};
      display: flex;
      flex-direction: column;
      row-gap: 4px;
      padding-top: 12px;
      padding-bottom: 20px;
      .component_switch_account_footer_item {
        display: flex;
        align-items: center;
        column-gap: 12px;
        padding: 16px 20px;
        cursor: pointer;
        :hover,
        :focus,
        :active {
          background: ${color.grey3};
        }
        .text {
          color: ${color.black1};
        }
        .anticon {
          font-size: 20px;
          color: ${color.black2};
        }
      }
    }
  }
`;

export const NotificationWrapper = styled.div`
  display: ${({ isShow }) => {
    return isShow ? 'block' : 'none';
  }};
  position: absolute;
  right: 50%;
  z-index: 10;

  .container_page_header_notification {
    position: relative;
    background: white;
    width: 390px;
    border-radius: 12px;
    box-shadow: ${boxShadow.normal};
    border: 1px solid ${color.grey1};
    .component_notification_header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      .component_notification_header_title {
        color: ${color.black1};
      }
      .component_notification_header_mark {
        color: ${color.orange1};
        cursor: pointer;
        :hover {
          color: ${color.orange2};
        }
      }
    }
    .component_notification_body {
      max-height: 460px;
      min-height: 280px;
      overflow-y: auto;
      ${thumbStyle};
      .component_notification_list_item:not(:last-child) {
        border-bottom: 1px solid ${color.grey1};
      }
      .container_notification_wrapper {
        cursor: pointer;
        :hover,
        :focus,
        :active {
          background: ${color.grey4};
        }
      }
      .component_notification_empty {
        margin-top: 32px;
        .component_notification_empty_text {
          color: ${color.black3};
        }
      }
    }
    .component_notification_footer {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 24px 20px 20px;
      .component_button_primary_transparent {
        height: 38px;
        line-height: 38px;
        padding: 0 28px;
      }
    }
  }
`;
